<script>
export default {
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.$store.commit('setLoading', true);
		});
	}
};
</script>
